"use client"

import { Clock, Coins } from "lucide-react"

import { SectionContainer } from "@shared/ui/landing/section-container"

import { networkMeta, supportedNetworks } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

export function NetworksSection() {
  const t = useTranslations("networks")

  return (
    <SectionContainer id="networks">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-brand">{t("title")}</h2>
        <p className="mt-3 text-muted-foreground">{t("subtitle")}</p>
      </div>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {supportedNetworks.map((network) => {
          const meta = networkMeta[network]
          return (
            <div
              key={network}
              className="rounded-2xl border border-brand bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
            >
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-brand">{t(`${network}.name`)}</h3>
                  <p className="text-xs text-muted-foreground">{meta.symbol}</p>
                </div>
                <Coins className="size-5 text-brand/60" />
              </div>
              <div className="mt-4 space-y-2 text-sm">
                <div className="flex items-center justify-between">
                  <span className="text-muted-foreground">{t("avgTime")}</span>
                  <span className="inline-flex items-center gap-1 font-medium text-brand">
                    <Clock className="size-3.5" />
                    {meta.avgTime}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-muted-foreground">{t("networkFee")}</span>
                  <span className="font-medium text-brand">{meta.fee}</span>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </SectionContainer>
  )
}
